import { render, staticRenderFns } from "./importBenefits.vue?vue&type=template&id=786c37d4&scoped=true&"
import script from "./importBenefits.vue?vue&type=script&lang=js&"
export * from "./importBenefits.vue?vue&type=script&lang=js&"
import style0 from "./importBenefits.vue?vue&type=style&index=0&id=786c37d4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786c37d4",
  null
  
)

export default component.exports